import { ROUTE_QUIZ_GOALS } from '@hungryroot/routes';
import { type RouteGroup } from '../defs/route-groups';
import {
  LUNCH_REFRESH_ROUTES,
  ROUTE_BREAKFAST,
  ROUTE_CUISINES,
  ROUTE_EATING_HABITS,
  ROUTE_EATING_HABITS_DIETARY_NEEDS,
  ROUTE_FLAVORS,
  ROUTE_FOOD_FORMATS,
  ROUTE_FOOD_QUALITIES,
  ROUTE_QUIZ_HELLO,
  ROUTE_MACRO_NUTRIENT,
  ROUTE_MEAT,
  ROUTE_PLANTS,
  ROUTE_POLARIZING,
  ROUTE_QUIZ_BUDGET,
  ROUTE_SEAFOOD,
  ROUTE_SNACKS,
  ROUTE_SWEETS,
} from '../defs/routes';

export const quizProgressAbout = [
  ROUTE_QUIZ_HELLO,
  ROUTE_QUIZ_GOALS,
  ROUTE_QUIZ_BUDGET,
  ROUTE_FOOD_FORMATS,
  ROUTE_EATING_HABITS,
  ROUTE_EATING_HABITS_DIETARY_NEEDS,
  ROUTE_MACRO_NUTRIENT,
  ROUTE_FOOD_QUALITIES,
] as const;

export const variantQuizProgressTastes = [
  ROUTE_MEAT,
  ROUTE_SEAFOOD,
  ROUTE_PLANTS,
  ROUTE_POLARIZING,
] as const;

export const quizProgressTastes = [
  ROUTE_CUISINES,
  ROUTE_FLAVORS,
  ...variantQuizProgressTastes,
] as const;

export const quizProgressRoutine = [
  ROUTE_BREAKFAST,
  ...LUNCH_REFRESH_ROUTES,
  ROUTE_SNACKS,
  ROUTE_SWEETS,
] as const;

export function getQuizProgressSections<T extends string>(
  aboutSection: readonly T[],
  tastesSection: readonly T[],
  routineSection: readonly T[]
): RouteGroup<T>[] {
  return [
    {
      header: 'About you',
      type: 'about',
      pages: aboutSection,
    },
    {
      header: 'Your tastes',
      type: 'tastes',
      pages: tastesSection,
    },
    {
      header: 'Your daily routine',
      type: 'routine',
      pages: routineSection,
    },
  ];
}
